export default __webpack_public_path__ + "static/media/epic_space.43204e22.mp3";